import React, { useState } from "react";
// import { useState } from "react";
import { Box } from "@mui/material";
import { InputBase, IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import { ReactComponent as SearchIcon } from "../../../../assets/images/searchIcon.svg";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router-dom";
import styles from "./style";
import Typography from "@mui/material/Typography";
import { ReactComponent as Location } from "../../../../assets/ViewLeave-images/location.svg";
import CustomPagination from "../../../../components/CustomPagination";


// import styles from "./style";

const RecruitmentPage = ({ data, role, permission, handleSearch, page, setPage, total }) => {
  // const theme = useTheme();
  const navigate = useNavigate()

  const [rowsPerPage, setRowsPerPage] = useState(10);

  // const [value] = useState(70); // Set initial value

  //   const handleChange = (event, newValue) => {
  //     setValue(newValue);
  //   };
  const handleNavigate = (item) => {
    navigate("/dashboard/viewRecruitment", { state: { item } })
  }


  return (
    <>
      <Box sx={styles.mainBox}>
        <Box sx={styles.searchSection}>
          <IconButton type="button" sx={{ p: 1, pr: 0.5, width: "27px" }}>
            <SearchIcon />
          </IconButton>
          <InputBase sx={styles.searchInput} onChange={(e) => handleSearch(e.target.value)} placeholder="Search" />
        </Box>
        <Box sx={styles.createJobButtonBox}>
          {(permission?.recruitment?.isEdit || role === "Admin" || role === "SuperAdmin") &&
            <Button variant="contained" color="success" sx={styles.jobButton} onClick={() => navigate("/dashboard/recruitment/createRecruitment")}>
              Create A New Job
            </Button>
          }
        </Box>
      </Box>
      <Box>
        <Grid container sx={{...styles.gridContainer, p:2}}>
          {data.length === 0 ? ( 
            <Grid item xs={12}>
              <Box sx={styles.alignBox}>
                <Typography variant="h6">No Data</Typography>
              </Box>
            </Grid>
          ) : (
            data?.map((item, index) => (
              <Grid item xs={12} sm={5} md={3.5} key={index} sx={{...styles.gridSection, m:2}}>
                <Box sx={styles.innerBox}>
                  <Box sx={styles.avatarGrid}>
                    <Avatar alt="image" src={item?.logo} sx={styles.avatar} />
                    <Box sx={styles.companyInfo}>
                      <Typography variant="body1" sx={styles.companyName} noWrap>
                        {item?.company[0]?.companyName}
                      </Typography>
                      <Typography sx={styles.position} noWrap>
                        {item.position}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={styles.salaryLocationBox}>
                  <Box sx={styles.salaryBox}>
                    {item?.isShowSalary && (
                      <Typography sx={styles.position} noWrap>
                        {`$${item.salaryStart}-$${item?.salaryEnd}`}
                      </Typography>
                    )}
                  </Box>
                  <Box sx={styles.locationBox}>
                    <Location />
                    <Typography sx={styles.locationText} noWrap>
                      {item.workplace}
                    </Typography>
                  </Box>
                </Box>
                <Typography sx={styles.content} noWrap>
                  {item?.desc}
                </Typography>
                <Box sx={styles.buttonBox}>
                  <Button 
                    variant="contained" 
                    color="success" 
                    disabled={item?.status === "Close"} 
                    sx={styles.viewBtn} 
                    onClick={() => handleNavigate(item)}
                    fullWidth
                  >
                    {item?.status === "Close" ? "Closed" : "View Applications"}
                  </Button>
                </Box>
              </Grid>
            ))
          )}


        </Grid>


      </Box>
      {data &&
        <CustomPagination
          pageCount={total}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          totalItems={data.length}
        />}


    </>
  );
};

export default RecruitmentPage;